import type { SxProps, Theme } from "@mui/material/styles";

import { MID } from "@/components/marketing/tokens";

/**
 * The home page's own type ramp.
 *
 * `MarketingShell`'s theme ramp was measured off the blog and the academy, and
 * its `h1` matches this page exactly, that one is used through `variant="h1"`.
 * Its `h2` and `h3` do not: the blog's `h2` is 36/43.2 stepping to 26/31.2,
 * where this page runs 36/48, steps only its line-height at 991, and lands at
 * 27/35.1. Rather than bend a shared theme to two curves, the roles this page
 * disagrees on are stated here and applied per element.
 *
 * Steps are declared widest-first so the narrowest rule wins on insertion
 * order, which is how emitted media queries resolve.
 */

/**
 * Every section heading. `is-centered-txt` is the Trustpilot band's only edit.
 * The rule is the site's, not this page's, so it lives beside the palette.
 */
export { HEADING_2 } from "@/components/marketing/marketingType";

/** The page's only `h3`, on the dark call-to-action bar. */
export const HEADING_3: SxProps<Theme> = {
  color: "common.white",
  fontSize: 22.4,
  lineHeight: "29.12px",
  fontWeight: 500,
  letterSpacing: "-0.02em",
  [MID]: { fontSize: 19.2, lineHeight: "24.96px" },
};

/** Both are site-wide classes, so they live beside the palette. */
export { BODY, BODY_SMALL } from "@/components/marketing/marketingType";
